import * as React from "react";
import { singleton } from "logic/singleton";
const HighlightingRules = React.createContext(void 0);
export default singleton("contexts.HighlightingRules", () => HighlightingRules);
